import { render } from "./DashboardBanner.vue?vue&type=template&id=d3d92824"
import script from "./DashboardBanner.vue?vue&type=script&lang=js"
export * from "./DashboardBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__